import { render, staticRenderFns } from "./ConfirmBusiness.vue?vue&type=template&id=2ee46d10&scoped=true&"
import script from "./ConfirmBusiness.vue?vue&type=script&lang=js&"
export * from "./ConfirmBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee46d10",
  null
  
)

export default component.exports